import { getTrainList,insertTrain,updateTrain,deleteTrain,updateFixed,getExamDriver,getExamQuestion } from "../../api/config/modules/DriverTrain";

const state = {
    getTrainList: {},
    insertTrain: {},
    updateTrain: {},
    deleteTrain: {},
    updateFixed: {},
    getExamDriver: {},
    getExamQuestion: {}
};

const mutations = {
  SET_GETTRAINLIST: (state, getTrainList) => {
    state.getTrainList = getTrainList;
  },
  SET_INSERTTRAIN: (state, insertTrain) => {
    state.insertTrain = insertTrain;
  },
  SET_UPDATETRAIN: (state, updateTrain) => {
    state.updateTrain = updateTrain;
  },
  SET_DELETETRAIN: (state, deleteTrain) => {
    state.deleteTrain = deleteTrain;
  },
  SET_UPDATEFIXED: (state, updateFixed) => {
    state.updateFixed = updateFixed;
  },
  SET_GETEXAMDRIVER: (state, getExamDriver) => {
    state.getExamDriver = getExamDriver;
  },
  SET_GETEXAMQUESTION: (state, getExamQuestion) => {
    state.getExamQuestion = getExamQuestion;
  }
};

const actions = {
  GET_GETTRAINLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getTrainList(data)
        .then((res) => {
          commit("SET_GETTRAINLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTTRAIN: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        insertTrain(data)
        .then((res) => {
          commit("SET_INSERTTRAIN", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATETRAIN: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        updateTrain(data)
        .then((res) => {
          commit("SET_UPDATETRAIN", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETETRAIN: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        deleteTrain(data)
        .then((res) => {
          commit("SET_DELETETRAIN", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATEFIXED: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        updateFixed(data)
        .then((res) => {
          commit("SET_UPDATEFIXED", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETEXAMDRIVER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getExamDriver(data)
        .then((res) => {
          commit("SET_GETEXAMDRIVER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETEXAMQUESTION: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getExamQuestion(data)
        .then((res) => {
          commit("SET_GETEXAMQUESTION", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
